export default class ProdutoDetailsController {
  constructor($q, $state, $scope, AuthenticationService, UIService, ProdutoService, Produto, ProdutoInvestigador, ProdutoEntidadeFinanciadora, ProdutoTipo, Investigador, EntidadeFinanciadora, Impacto, ImpactoOds, Ods, Pais) {
    this.$q = $q;
    this.$state = $state;
    this.$scope = $scope;
    this.UI = UIService;
    this.user = AuthenticationService.getUser();
    this.ProdutoService = ProdutoService;
    this.loaded = false;
    this.simnao = [{ name: "Sim", value: 1 }, { name: "Não", value: 0 }];
    this.Produto = Produto;
    this.ProdutoEntidadeFinanciadora = ProdutoEntidadeFinanciadora;
    this.ProdutoInvestigador = ProdutoInvestigador;
    this.ProdutoTipo = ProdutoTipo;
    this.Investigador = Investigador;
    this.EntidadeFinanciadora = EntidadeFinanciadora;
    this.Impacto = Impacto;
    this.ImpactoOds = ImpactoOds;
    this.Ods = Ods;
    this.Pais = Pais;
    this.showEstadosPanel = false;

    this.loaded = false;

    // Default opt state - populate later when we have all states
    this.optEntidadesFinanciadoras = {
      total: 0,
      start: 0,
      end: 0,
      page: 1,
      items: 3,
      order: "id",
      sort: "desc",
      filter: {},
      filterLayout: {}
    };
    this.entidadesFinanciadoras = null;
    this.entidadesFinanciadorasLoading = true;

    // Default opt state - populate later when we have all states
    this.optInvestigadores = {
      total: 0,
      start: 0,
      end: 0,
      page: 1,
      items: 3,
      order: "id",
      sort: "desc",
      filter: {},
      filterLayout: {}
    };
    this.investigadores = null;
    this.investigadoresLoading = true;

    // Default opt state - populate later when we have all states
    this.optImpactosOds = {
      total: 0,
      start: 0,
      end: 0,
      page: 1,
      items: 3,
      order: "id",
      sort: "desc",
      filter: {},
      filterLayout: {}
    };
    this.impactosOds = null;
    this.impactosOdsLoading = true;

    this.id = $state.params.id;

    this.loadData();
    this.limit = 3;
  }

  limitTo = () => {
    if (angular.isDefined(this.limit)) {
      this.limit = undefined;
    } else {
      this.limit = 3;
    }
  };

  loadData = () => {
    this.loaded = false;
    this.Produto.findOne({
      filter: {
        where: {
          id: this.id
        },
        include: ['criadoPor', 'atualizadoPor', 'produtoTipo', 'impacto', {
          relation: 'investigadores',
          scope: {
            include: {
              relation: 'investigador',
              scope: {
                fields: {userId: true}
              }
            }
          }
        }]
      }
    }).$promise.then(res => {
      this.data = res;

      this.getImpactosOdsForImpacto(); // We can only load this after getting impactoId
      this.getEntidadesFinanciadorasForProduto();
      this.getInvestigadoresForProduto();

      this.loaded = true;
    }).catch((error) => {
      console.log(error);
      this.$state.go('app.produto.list');
      this.UI.addToast('Erro ao carregar produto. Verifique a ligação');
    });

  };

  editDetalhes = () => {
    let wait = this.UI.showWaiting();
    this.ProdutoTipo.find({}).$promise.then((produtosTipo) => {
      wait.close();
      let options = {
        size: 'lg',
        template: require('./details.dialog.html'),
        controller: ['$scope', ($scope) => {
          $scope.label = "Editar Produto";
          $scope.produto = angular.copy(this.data);
          $scope.produtosTipo = produtosTipo;
          $scope.simnao = this.simnao;

          $scope.auxTipo = {
            selected: $scope.produto.produtoTipo,
            infiniteScroll: {numToAdd: 20, currentItems: 20}
          };
          $scope.auxOpenAccess = {
            selected: $scope.produto.openAccess ? $scope.simnao.find(x => x.value === 1) : $scope.simnao.find(x => x.value === 0),
            infiniteScroll: {numToAdd: 20, currentItems: 20}
          };
          $scope.auxRelatorioDisponivel = {
            selected: $scope.produto.relatorioDisponivel ? $scope.simnao.find(x => x.value === 1) : $scope.simnao.find(x => x.value === 0),
            infiniteScroll: {numToAdd: 20, currentItems: 20}
          };
          $scope.auxMadeAvailable = {
            selected: $scope.produto.madeAvailable ? $scope.simnao.find(x => x.value === 1) : $scope.simnao.find(x => x.value === 0),
            infiniteScroll: {numToAdd: 20, currentItems: 20}
          };

          // Current year as max be able to add ano
          $scope.year = moment().format('YYYY');

          // Infinite Scroll magic
          $scope.addMoreItems = (infiniteScroll) => {
            infiniteScroll.currentItems += infiniteScroll.numToAdd;
          };

          $scope.ok = () => {
            $scope.$close($scope);
          };

          $scope.cancel = () => $scope.$dismiss('cancel');
        }]
      };

      this.UI.showDialog(options).then(ok => {
        this.loaded = false;

        this.data.designacao = ok.produto.designacao;
        this.data.ano = ok.produto.ano;
        this.data.descricao = ok.produto.descricao;
        this.data.www = ok.produto.www;
        this.data.destinatarios = ok.produto.destinatarios;

        this.data.produtoTipoId = ok.auxTipo.selected.id;
        this.data.produtoTipo = ok.auxTipo.selected;

        this.data.openAccess = ok.auxOpenAccess.selected.value;
        this.data.relatorioDisponivel = ok.auxRelatorioDisponivel.selected.value;
        this.data.madeAvailable = ok.auxMadeAvailable.selected.value;

        this.data.atualizadoPorId = this.user.id;
        this.data.atualizadoa = moment().format();

        this.Produto.upsert(this.data).$promise.then(() => {
          this.UI.addToast("Dados atualizados com sucesso");
          this.loadData();
        }).catch((error) => {
          console.log(error);
          this.UI.showAlert("Erro ao atualizar produto. Verifique a ligação");
          this.loaded = true;
        });
      });
    }).catch(err => {
      wait.close();
      console.log(err);
      this.UI.addToast("Erro ao carregar tipos de produto. Verifique a sua ligação");
    });
  };

  editObservacoes = () => {
    let options = {
      size: 'lg',
      template: require('./observacoes.dialog.html'),
      controller: ['$scope', ($scope) => {
        $scope.label = "Editar Observações";
        $scope.observacoes = angular.copy(this.data.observacoes);

        $scope.ok = () => {
          $scope.$close($scope);
        };

        $scope.cancel = () => $scope.$dismiss('cancel');
      }]
    };

    this.UI.showDialog(options).then(ok => {
      this.loaded = false;
      if (ok.observacoes !== 0 && !ok.observacoes)
        ok.observacoes = null;
      this.data.observacoes = ok.observacoes;
      this.data.atualizadoPorId = this.user.id;
      this.data.atualizadoa = moment().format();
      this.Produto.upsert(this.data).$promise.then(() => {
        this.UI.addToast("Observações atualizadas com sucesso");
        this.loadData();
      }).catch((error) => {
        console.log(error);
        this.UI.showAlert("Erro ao atualizar produto. Verifique a ligação");
        this.loaded = true;
      });
    });
  };


  // Multiple data
  // Co-Autores
  investigadoreslModalOptions = (data, edit) => {
    let defer = this.$q.defer();

    let investigador = {};
    let auxInvestigadorSelection = undefined;
    if (edit && data != null) {
      investigador = angular.copy(data);
      auxInvestigadorSelection = investigador.investigador;
    }
    let wait = this.UI.showWaiting();
    this.Investigador.find({}).$promise.then((investigadores) => {
      investigadores.sort((a, b) => a.nome.localeCompare(b.nome));
      wait.close();
      defer.resolve({
        size: 'lg',
        template: require('./../new/edit.investigador.dialog.html'),
        controller: ['$dialog', '$scope', (dialog, scope) => {
          scope.label = (edit ? "Editar" : "Novo") + " co-autor";
          scope.investigador = investigador;
          scope.investigadores = investigadores;

          scope.auxInvestigador = {
            selected: auxInvestigadorSelection,
            infiniteScroll: {numToAdd: 20, currentItems: 20}
          };

          // Infinite Scroll magic
          scope.addMoreItems = (infiniteScroll) => {
            infiniteScroll.currentItems += infiniteScroll.numToAdd;
          };

          scope.ok = () => {
            dialog.close(scope);
          };

          scope.cancel = () => {
            dialog.dismiss('cancel');
          };
        }]
      });
    }).catch((error) => {
      wait.close();
      console.log(error);
      this.UI.addToast("Não foi possível ler investigadores. Verifique a sua ligação");
      defer.reject();
    });
    return defer.promise;
  };

  // Adicionar um novo co-autor para projeto
  addInvestigador = () => {
    this.investigadoreslModalOptions(null, false).then(options => {
      let dialogEdit = this.UI.showDialog(options);
      dialogEdit.then(ok => {
        if (ok.auxInvestigador && ok.investigador) {
          this.investigadoresLoading = true;
          let item = angular.copy(ok.investigador);
          item.investigadorId = ok.auxInvestigador.selected.id;
          item.investigador = angular.copy(ok.auxInvestigador.selected);
          // Check if investigador is already there before creating
          this.ProdutoService.usedPartialDataForModel({produtoId: this.id, investigadorId: item.investigadorId}, this.ProdutoInvestigador).then(res => {
            if (res.count > 0) { // Already exists
              this.UI.addToast("Autor já existe");
              this.investigadoresLoading = false;
            } else { // Create it
              this.ProdutoService.createMultipleData(this.ProdutoInvestigador, [item], this.id, 'produtoId').then(() => {
                this.UI.addToast("Autor adicionado com sucesso");
                this.getInvestigadoresForProduto();
              }).catch(error => {
                this.investigadoresLoading = false;
                this.UI.addToast("Erro ao inserir autor. Verifique a ligação");
                console.log(error);
              });
            }
          }).catch((error) => {
            this.investigadoresLoading = false;
            this.UI.addToast("Erro de criação. Verifique a ligação.");
            console.log(error);
          });
        }
      });
    }).catch(() => {}); // Already dealt with upstream
  };

  // Ask confirmation to delete entrada/saida
  confirmDeleteInvestigador = (x) => {
    let title = "Eliminar Autor do Projeto";
    let warning = "Tem a certeza que pretende remover este co-autor?";
    let instance = this.UI.showDialog({
      size: 'md',
      template: require('../../interface/modals/delete-selected.html'),
      controller: ['$scope', function ($scope) {
        $scope.title = title;
        $scope.message = warning;
        $scope.ok = function () {
          $scope.$close();
        };
        $scope.cancel = function () {
          $scope.$dismiss('cancel');
        };
      }]
    });

    instance.then(() => {
      this.removeInvestigador(x);
    }, (err) => {
      if (err !== 'cancel' && err !== 'escape key press' && err !== 'backdrop click')
        console.log(err);
    })
  };

  removeInvestigador = (x) => {
    this.investigadoresLoading = true;
    // Find again equipa editorial to delete, so we can update it
    this.ProdutoInvestigador.findOne({
      filter: {
        where: {
          id: x.id
        }
      }
    }).$promise.then((investigadorToRemove) => {
      // Only for mandatory existing multiple data
      this.ProdutoInvestigador.count({
        fields: {id: true},
        where: {
          produtoId: this.id
        }
      }).$promise.then((res) => {
        if (res.count > 1) {

          // Remove data
          this.ProdutoInvestigador.deleteById({
            id: investigadorToRemove.id,
          }).$promise.then(() => {
            this.UI.addToast("Autor removido com sucesso");
            this.getInvestigadoresForProduto();
          });

        } else { // No other autores exist, can't remove
          this.investigadoresLoading = false;
          this.UI.showAlert("Não foi possível apagar autor porque tem que haver pelo menos 1 registo para o produto");
        }
      }).catch((error) => {
        console.log(error);
        this.UI.addToast("Não foi possível consultar Produto. Verifique a ligação");
        this.getInvestigadoresForProduto();
      });
    }).catch((error) => {
      console.log(error);
      this.UI.addToast("Não foi possível eliminar co-autor. Verifique se ainda existe.");
      this.getInvestigadoresForProduto();
    });
  };

  getInvestigadoresForProduto = () => {
    this.investigadoresLoading = true;
    let whereLiteral = {
      'ProdutoInvestigador.produtoId': this.id
    };
    let where = {};
    Object.keys(this.optInvestigadores.filter).forEach(f => {
      if (this.optInvestigadores.filter[f])
        where[f] = this.optInvestigadores.filter[f];
    });
    this.ProdutoInvestigador.table({
      params: {
        fields: [
          'ProdutoInvestigador.id as id',
          'ProdutoInvestigador.produtoId as produtoId',
          'ProdutoInvestigador.investigadorId as investigadorId',
          'ProdutoInvestigador.dataCriacao as dataCriacao',
          'ProdutoInvestigador.atualizadoa as atualizadoa',
          'ProdutoInvestigador.criadoPorId as criadoPorId',
          'User.name as criadoPor',
          'User2.name as atualizadoPor',
          'Investigador.id as auxInvestigadorId',
          'Investigador.nome as auxInvestigadorNome'
        ],
        from: ['ProdutoInvestigador', 'User', 'User', 'Investigador'],
        references: [undefined, 'ProdutoInvestigador.criadoPorId', 'ProdutoInvestigador.atualizadoPorId', 'ProdutoInvestigador.investigadorId'],
        aliases: [null, null, 'User2', null],
        where: where,
        whereLiteral: whereLiteral,
        order: this.optInvestigadores.order,
        sort: this.optInvestigadores.sort,
        limit: this.optInvestigadores.items,
        skip: (this.optInvestigadores.page - 1) * this.optInvestigadores.items,
      }
    }).$promise.then(res => {
      let page = this.optInvestigadores.page;
      let items = this.optInvestigadores.items;

      let total = res.count;

      this.optInvestigadores.start = total > 0 ? (page - 1) * items + 1 : 0;
      if ((this.optInvestigadores.start - 1 + items) >= total) {
        this.optInvestigadores.end = total;
      } else {
        this.optInvestigadores.end = Number.parseInt(this.optInvestigadores.start - 1 + items);
      }

      // Process sub-data
      res.data.forEach(x => {
        x.investigador = {
          id: x.auxInvestigadorId,
          nome: x.auxInvestigadorNome
        };
      });

      this.investigadores = res.data;
      this.optInvestigadores.total = total;
      this.investigadoresLoading = false;
    }).catch((e) => {
      console.log(e);
      this.UI.addToast("Não foi possível ler co-autores. Verifique a ligação");
    });
  };

  investigadorSort = keyname => {
    if (this.optInvestigadores.order === keyname)
      this.optInvestigadores.page = 1;
    this.optInvestigadores.order = keyname;
    this.optInvestigadores.sort = this.optInvestigadores.sort === 'asc' ? 'desc' : 'asc';
    this.getInvestigadoresForProduto();
  };

  investigadorItem = val => {
    this.optInvestigadores.items = val;
    this.optInvestigadores.page = 1;
    this.getInvestigadoresForProduto();
  };

  investigadorPage = sum => {
    this.optInvestigadores.page += sum;
    if (this.optInvestigadores.page < 1)
      this.optInvestigadores.page = 1;
    if (this.optInvestigadores.page > Math.ceil(this.optInvestigadores.total / this.optInvestigadores.items))
      this.optInvestigadores.page = Math.ceil(this.optInvestigadores.total / this.optInvestigadores.items);
    this.getInvestigadoresForProduto();
  };

  viewInvestigador = x => {
    this.UI.showDialog({
      size: 'md',
      template: require('./investigador.info.dialog.html'),
      controller: ['$scope', function ($scope) {
        $scope.data = angular.copy(x);
        $scope.data.dataCriacao = moment($scope.data.dataCriacao).isValid() ? moment($scope.data.dataCriacao).format('DD/MM/YYYY HH:mm:ss') : null;
        $scope.data.atualizadoa = moment($scope.data.atualizadoa).isValid() ? moment($scope.data.atualizadoa).format('DD/MM/YYYY HH:mm:ss') : null;
        $scope.fechar = function () {
          $scope.$close();
        };
      }]
    });
  };


  // Entidades Financiadoras
  entidadesFinanciadorasModalOptions = (data, edit) => {
    let defer = this.$q.defer();

    let entidadeFinanciadora = {};
    let auxEntidadeFinanciadoraSelection = undefined;
    if (edit && data != null) {
      entidadeFinanciadora = angular.copy(data);
      auxEntidadeFinanciadoraSelection = entidadeFinanciadora.entidadeFinanciadora;
    }
    let wait = this.UI.showWaiting();
    this.EntidadeFinanciadora.find({}).$promise.then((entidadesFinanciadoras) => {
      wait.close();
      defer.resolve({
        size: 'lg',
        template: require('./../new/edit.entidade.financiadora.dialog.html'),
        controller: ['$dialog', '$scope', (dialog, scope) => {
          scope.label = (edit ? "Editar" : "Nova") + " Entidade";
          scope.entidadeFinanciadora = entidadeFinanciadora;
          scope.entidadesFinanciadoras = entidadesFinanciadoras;

          scope.auxEntidadeFinanciadora = {
            selected: auxEntidadeFinanciadoraSelection,
            infiniteScroll: {numToAdd: 20, currentItems: 20}
          };

          // Infinite Scroll magic
          scope.addMoreItems = (infiniteScroll) => {
            infiniteScroll.currentItems += infiniteScroll.numToAdd;
          };

          scope.ok = () => {
            dialog.close(scope);
          };

          scope.cancel = () => {
            dialog.dismiss('cancel');
          };
        }]
      });
    }).catch((error) => {
      wait.close();
      console.log(error);
      this.UI.addToast("Não foi possível ler Entidades. Verifique a sua ligação");
      defer.reject();
    });
    return defer.promise;
  };

  // Adicionar um nova entidade para produto
  addEntidadeFinanciadora = () => {
    this.entidadesFinanciadorasModalOptions(null, false).then(options => {
      let dialogEdit = this.UI.showDialog(options);
      dialogEdit.then(ok => {
        if (ok.auxEntidadeFinanciadora && ok.entidadeFinanciadora) {
          this.entidadesFinanciadorasLoading = true;
          let item = angular.copy(ok.entidadeFinanciadora);
          item.entidadeFinanciadoraId = ok.auxEntidadeFinanciadora.selected.id;
          item.entidadeFinanciadora = angular.copy(ok.auxEntidadeFinanciadora.selected);
          // Check if entidade financiadora is already there before creating
          this.ProdutoService.usedPartialDataForModel({produtoId: this.id, entidadeFinanciadoraId: item.entidadeFinanciadoraId}, this.ProdutoEntidadeFinanciadora).then(res => {
            if (res.count > 0) { // Already exists
              this.UI.addToast("Entidade já existe");
              this.entidadesFinanciadorasLoading = false;
            } else { // Create it
              this.ProdutoService.createMultipleData(this.ProdutoEntidadeFinanciadora, [item], this.id, 'produtoId').then(() => {
                this.UI.addToast("Entidade adicionada com sucesso");
                this.getEntidadesFinanciadorasForProduto();
              }).catch(error => {
                this.entidadesFinanciadorasLoading = false;
                this.UI.addToast("Erro ao inserir entidade. Verifique a ligação");
                console.log(error);
              });
            }
          }).catch((error) => {
            this.entidadesFinanciadorasLoading = false;
            this.UI.addToast("Erro de criação. Verifique a ligação.");
            console.log(error);
          });
        }
      });
    }).catch(() => {}); // Already dealt with upstream
  };

  // Ask confirmation to delete entidade
  confirmDeleteEntidadeFinanciadora = (x) => {
    let title = "Eliminar Entidade do Projeto";
    let warning = "Tem a certeza que pretende remover esta entidade do projeto?";
    let instance = this.UI.showDialog({
      size: 'md',
      template: require('../../interface/modals/delete-selected.html'),
      controller: ['$scope', function ($scope) {
        $scope.title = title;
        $scope.message = warning;
        $scope.ok = function () {
          $scope.$close();
        };
        $scope.cancel = function () {
          $scope.$dismiss('cancel');
        };
      }]
    });

    instance.then(() => {
      this.removeEntidadeFinanciadora(x);
    }, (err) => {
      if (err !== 'cancel' && err !== 'escape key press' && err !== 'backdrop click')
        console.log(err);
    })
  };

  removeEntidadeFinanciadora = (x) => {
    this.entidadesFinanciadorasLoading = true;
    // Find again equipa editorial to delete, so we can update it
    this.ProdutoEntidadeFinanciadora.findOne({
      filter: {
        where: {
          id: x.id
        }
      }
    }).$promise.then((entidadeFinanciadoraToRemove) => {
      // Only for mandatory existing multiple data

      // Remove data
      this.ProdutoEntidadeFinanciadora.deleteById({
        id: entidadeFinanciadoraToRemove.id,
      }).$promise.then(() => {
        this.UI.addToast("Entidade removida com sucesso");
        this.getEntidadesFinanciadorasForProduto();
      });

    }).catch((error) => {
      console.log(error);
      this.UI.addToast("Não foi possível eliminar entidade. Verifique se ainda existe.");
      this.getEntidadesFinanciadorasForProduto();
    });
  };

  getEntidadesFinanciadorasForProduto = () => {
    this.entidadesFinanciadorasLoading = true;
    let whereLiteral = {
      'ProdutoEntidadeFinanciadora.produtoId': this.id
    };
    let where = {};
    Object.keys(this.optEntidadesFinanciadoras.filter).forEach(f => {
      if (this.optEntidadesFinanciadoras.filter[f])
        where[f] = this.optEntidadesFinanciadoras.filter[f];
    });
    this.ProdutoEntidadeFinanciadora.table({
      params: {
        fields: [
          'ProdutoEntidadeFinanciadora.id as id',
          'ProdutoEntidadeFinanciadora.produtoId as produtoId',
          'ProdutoEntidadeFinanciadora.entidadeFinanciadoraId as entidadeFinanciadoraId',
          'ProdutoEntidadeFinanciadora.dataCriacao as dataCriacao',
          'ProdutoEntidadeFinanciadora.atualizadoa as atualizadoa',
          'ProdutoEntidadeFinanciadora.criadoPorId as criadoPorId',
          'User.name as criadoPorName',
          'User2.name as atualizadoPorName',
          'EntidadeFinanciadora.id as auxEntidadeFinanciadoraId',
          'EntidadeFinanciadora.designacao as auxEntidadeFinanciadoraDesignacao'
        ],
        from: ['ProdutoEntidadeFinanciadora', 'User', 'User', 'EntidadeFinanciadora'],
        references: [undefined, 'ProdutoEntidadeFinanciadora.criadoPorId', 'ProdutoEntidadeFinanciadora.atualizadoPorId', 'ProdutoEntidadeFinanciadora.entidadeFinanciadoraId'],
        aliases: [null, null, 'User2', null],
        where: where,
        whereLiteral: whereLiteral,
        order: this.optEntidadesFinanciadoras.order,
        sort: this.optEntidadesFinanciadoras.sort,
        limit: this.optEntidadesFinanciadoras.items,
        skip: (this.optEntidadesFinanciadoras.page - 1) * this.optEntidadesFinanciadoras.items,
      }
    }).$promise.then(res => {
      let page = this.optEntidadesFinanciadoras.page;
      let items = this.optEntidadesFinanciadoras.items;

      let total = res.count;

      this.optEntidadesFinanciadoras.start = total > 0 ? (page - 1) * items + 1 : 0;
      if ((this.optEntidadesFinanciadoras.start - 1 + items) >= total) {
        this.optEntidadesFinanciadoras.end = total;
      } else {
        this.optEntidadesFinanciadoras.end = Number.parseInt(this.optEntidadesFinanciadoras.start - 1 + items);
      }

      // Process sub-data
      res.data.forEach(x => {
        x.entidadeFinanciadora = {
          id: x.auxEntidadeFinanciadoraId,
          designacao: x.auxEntidadeFinanciadoraDesignacao
        };
      });

      this.entidadesFinanciadoras = res.data;
      this.optEntidadesFinanciadoras.total = total;
      this.entidadesFinanciadorasLoading = false;
    }).catch((e) => {
      console.log(e);
      this.UI.addToast("Não foi possível ler entidades. Verifique a ligação");
    });
  };

  entidadeFinanciadoraSort = keyname => {
    if (this.optEntidadesFinanciadoras.order === keyname)
      this.optEntidadesFinanciadoras.page = 1;
    this.optEntidadesFinanciadoras.order = keyname;
    this.optEntidadesFinanciadoras.sort = this.optEntidadesFinanciadoras.sort === 'asc' ? 'desc' : 'asc';
    this.getEntidadesFinanciadorasForProduto();
  };

  entidadeFinanciadoraItem = val => {
    this.optEntidadesFinanciadoras.items = val;
    this.optEntidadesFinanciadoras.page = 1;
    this.getEntidadesFinanciadorasForProduto();
  };

  entidadeFinanciadoraPage = sum => {
    this.optEntidadesFinanciadoras.page += sum;
    if (this.optEntidadesFinanciadoras.page < 1)
      this.optEntidadesFinanciadoras.page = 1;
    if (this.optEntidadesFinanciadoras.page > Math.ceil(this.optEntidadesFinanciadoras.total / this.optEntidadesFinanciadoras.items))
      this.optEntidadesFinanciadoras.page = Math.ceil(this.optEntidadesFinanciadoras.total / this.optEntidadesFinanciadoras.items);
    this.getEntidadesFinanciadorasForProduto();
  };

  viewEntidadeFinanciadora = x => {
    this.UI.showDialog({
      size: 'md',
      template: require('./entidade.financiadora.info.dialog.html'),
      controller: ['$scope', function ($scope) {
        $scope.data = angular.copy(x);
        $scope.data.dataCriacao = moment($scope.data.dataCriacao).isValid() ? moment($scope.data.dataCriacao).format('DD/MM/YYYY HH:mm:ss') : null;
        $scope.data.atualizadoa = moment($scope.data.atualizadoa).isValid() ? moment($scope.data.atualizadoa).format('DD/MM/YYYY HH:mm:ss') : null;
        $scope.fechar = function () {
          $scope.$close();
        };
      }]
    });
  };


  // Impactos
  // Edit Impacto Ambiental, Económico, Social
  editImpactos = () => {
    let options = {
      size: 'lg',
      template: require('./impactos.dialog.html'),
      controller: ['$scope', ($scope) => {
        $scope.label = "Editar Impacto Ambiental, Económico, Social";
        $scope.impacto = angular.copy(this.data.impacto);
        $scope.simnao = this.simnao;

        $scope.auxImpactoAmbiental = {
          selected: $scope.impacto.ambiental ? $scope.simnao.find(x => x.value === 1) : $scope.simnao.find(x => x.value === 0),
          infiniteScroll: {numToAdd: 20, currentItems: 20}
        };
        $scope.auxImpactoEconomico = {
          selected: $scope.impacto.economico ? $scope.simnao.find(x => x.value === 1) : $scope.simnao.find(x => x.value === 0),
          infiniteScroll: {numToAdd: 20, currentItems: 20}
        };
        $scope.auxImpactoSocial = {
          selected: $scope.impacto.social ? $scope.simnao.find(x => x.value === 1) : $scope.simnao.find(x => x.value === 0),
          infiniteScroll: {numToAdd: 20, currentItems: 20}
        };
        $scope.auxImpactoPolicyInfluence = {
          selected: $scope.impacto.policyInfluence ? $scope.simnao.find(x => x.value === 1) : $scope.simnao.find(x => x.value === 0),
          infiniteScroll: {numToAdd: 20, currentItems: 20}
        };

        // Infinite Scroll magic
        $scope.addMoreItems = (infiniteScroll) => {
          infiniteScroll.currentItems += infiniteScroll.numToAdd;
        };

        $scope.ok = () => {
          $scope.$close($scope);
        };

        $scope.cancel = () => $scope.$dismiss('cancel');
      }]
    };

    this.UI.showDialog(options).then(ok => {
      this.loaded = false;

      // Ambiental
      if (ok.auxImpactoAmbiental.selected.value) {
        this.data.impacto.ambiental = ok.impacto.ambiental;
      } else {
        this.data.impacto.ambiental = null;
      }
      // Económico
      if (ok.auxImpactoEconomico.selected.value) {
        this.data.impacto.economico = ok.impacto.economico;
      } else {
        this.data.impacto.economico = null;
      }
      // Social
      if (ok.auxImpactoSocial.selected.value) {
        this.data.impacto.social = ok.impacto.social;
      } else {
        this.data.impacto.social = null;
      }
      // Policy influence
      if (ok.auxImpactoPolicyInfluence.selected.value) {
        this.data.impacto.policyInfluence = ok.impacto.policyInfluence;
      } else {
        this.data.impacto.policyInfluence = null;
      }

      this.data.impacto.observacoes = ok.impacto.observacoes || null;

      this.data.impacto.criadoPorId = this.user.id;
      this.data.impacto.dataCriacao = moment().format();

      this.Impacto.upsert(this.data.impacto).$promise.then(() => {
        this.UI.addToast("Impactos atualizados com sucesso");
        this.loadData();
      }).catch((error) => {
        console.log(error);
        this.UI.showAlert("Erro ao atualizar impactos. Verifique a ligação");
        this.loaded = true;
      });
    });
  };

  //Impactos ODS
  impactosOdsModalOptions = (data, edit) => {
    let defer = this.$q.defer();

    let ods = {};
    let auxOdsSelection = undefined;
    if (edit && data != null) {
      ods = angular.copy(data);
      auxOdsSelection = ods.ods;
    }
    let wait = this.UI.showWaiting();
    this.Ods.find({}).$promise.then((externalData) => {
      wait.close();
      defer.resolve({
        size: 'lg',
        template: require('./../new/impacto.dialog.html'),
        controller: ['$dialog', '$scope', (dialog, scope) => {
          scope.label = (edit ? "Editar" : "Novo") + " Impacto ODS";
          scope.ods = ods;
          scope.externalData = externalData;
          scope.tipo = 'ODS';

          scope.auxOds = {
            selected: auxOdsSelection,
            infiniteScroll: {numToAdd: 20, currentItems: 20}
          };

          // Infinite Scroll magic
          scope.addMoreItems = (infiniteScroll) => {
            infiniteScroll.currentItems += infiniteScroll.numToAdd;
          };

          scope.ok = () => {
            dialog.close(scope);
          };

          scope.cancel = () => {
            dialog.dismiss('cancel');
          };
        }]
      });
    }).catch((error) => {
      wait.close();
      console.log(error);
      this.UI.addToast("Não foi possível ler Impactos ODS. Verifique a sua ligação");
      defer.reject();
    });
    return defer.promise;
  };

  // Adicionar um novo ODS para impacto
  addImpactoOds = () => {
    this.impactosOdsModalOptions(null, false).then(options => {
      let dialogEdit = this.UI.showDialog(options);
      dialogEdit.then(ok => {
        if (ok.auxOds && ok.ods) {
          this.impactosOdsLoading = true;
          let item = angular.copy(ok.ods);
          item.odsId = ok.auxOds.selected.id;
          item.ods = angular.copy(ok.auxOds.selected);
          // Check if ODS is already there before creating
          this.ProdutoService.usedPartialDataForModel({impactoId: this.data.impactoId, odsId: item.odsId}, this.ImpactoOds).then(res => {
            if (res.count > 0) { // Already exists
              this.UI.addToast("Impacto ODS já existe");
              this.impactosOdsLoading = false;
            } else { // Create it
              this.ProdutoService.createMultipleData(this.ImpactoOds, [item], this.data.impactoId, 'impactoId').then(() => {
                this.UI.addToast("ODS adicionado com sucesso");
                this.getImpactosOdsForImpacto();
              }).catch(error => {
                this.impactosOdsLoading = false;
                this.UI.addToast("Erro ao inserir ODS. Verifique a ligação");
                console.log(error);
              });
            }
          }).catch((error) => {
            this.impactosOdsLoading = false;
            this.UI.addToast("Erro de criação. Verifique a ligação.");
            console.log(error);
          });
        }
      });
    }).catch(() => {}); // Already dealt with upstream
  };

  // Ask confirmation to delete ODS
  confirmDeleteImpactoOds = (x) => {
    let title = "Eliminar Impacto ODS";
    let warning = "Tem a certeza que pretende remover este impacto ODS?";
    let instance = this.UI.showDialog({
      size: 'md',
      template: require('../../interface/modals/delete-selected.html'),
      controller: ['$scope', function ($scope) {
        $scope.title = title;
        $scope.message = warning;
        $scope.ok = function () {
          $scope.$close();
        };
        $scope.cancel = function () {
          $scope.$dismiss('cancel');
        };
      }]
    });

    instance.then(() => {
      this.removeImpactoOds(x);
    }, (err) => {
      if (err !== 'cancel' && err !== 'escape key press' && err !== 'backdrop click')
        console.log(err);
    })
  };

  removeImpactoOds = (x) => {
    this.impactosOdsLoading = true;
    // Find again impacto ods to delete, so we can update it
    this.ImpactoOds.findOne({
      filter: {
        where: {
          id: x.id
        }
      }
    }).$promise.then((impactoOdsToRemove) => {
      // Only for mandatory existing multiple data

      // Remove data
      this.ImpactoOds.deleteById({
        id: impactoOdsToRemove.id,
      }).$promise.then(() => {
        this.UI.addToast("Impacto ODS removido com sucesso");
        this.getImpactosOdsForImpacto();
      });

    }).catch((error) => {
      console.log(error);
      this.UI.addToast("Não foi possível eliminar impacto ODS. Verifique se ainda existe.");
      this.getImpactosOdsForImpacto();
    });
  };

  getImpactosOdsForImpacto = () => {
    this.impactosOdsLoading = true;
    let whereLiteral = {
      'ImpactoOds.impactoId': this.data.impactoId
    };
    let where = {};
    Object.keys(this.optImpactosOds.filter).forEach(f => {
      if (this.optImpactosOds.filter[f])
        where[f] = this.optImpactosOds.filter[f];
    });
    this.ImpactoOds.table({
      params: {
        fields: [
          'ImpactoOds.id as id',
          'ImpactoOds.impactoId as impactoId',
          'ImpactoOds.odsId as odsId',
          'ImpactoOds.dataCriacao as dataCriacao',
          'User.name as criadoPor',
          'Ods.id as auxOdsId',
          'Ods.designacao as auxOdsDesignacao'
        ],
        from: ['ImpactoOds', 'User', 'Ods'],
        references: [undefined, 'ImpactoOds.criadoPorId', 'ImpactoOds.odsId'],
        where: where,
        whereLiteral: whereLiteral,
        order: this.optImpactosOds.order,
        sort: this.optImpactosOds.sort,
        limit: this.optImpactosOds.items,
        skip: (this.optImpactosOds.page - 1) * this.optImpactosOds.items,
      }
    }).$promise.then(res => {
      let page = this.optImpactosOds.page;
      let items = this.optImpactosOds.items;

      let total = res.count;

      this.optImpactosOds.start = total > 0 ? (page - 1) * items + 1 : 0;
      if ((this.optImpactosOds.start - 1 + items) >= total) {
        this.optImpactosOds.end = total;
      } else {
        this.optImpactosOds.end = Number.parseInt(this.optImpactosOds.start - 1 + items);
      }

      // Process sub-data
      res.data.forEach(x => {
        x.ods = {
          id: x.auxOdsId,
          designacao: x.auxOdsDesignacao
        };
      });

      this.impactosOds = res.data;
      this.optImpactosOds.total = total;
      this.impactosOdsLoading = false;
    }).catch((e) => {
      console.log(e);
      this.UI.addToast("Não foi possível ler ODS. Verifique a ligação");
    });
  };

  impactoOdsSort = keyname => {
    if (this.optImpactosOds.order === keyname)
      this.optImpactosOds.page = 1;
    this.optImpactosOds.order = keyname;
    this.optImpactosOds.sort = this.optImpactosOds.sort === 'asc' ? 'desc' : 'asc';
    this.getImpactosOdsForImpacto();
  };

  impactoOdsItem = val => {
    this.optImpactosOds.items = val;
    this.optImpactosOds.page = 1;
    this.getImpactosOdsForImpacto();
  };

  impactoOdsPage = sum => {
    this.optImpactosOds.page += sum;
    if (this.optImpactosOds.page < 1)
      this.optImpactosOds.page = 1;
    if (this.optImpactosOds.page > Math.ceil(this.optImpactosOds.total / this.optImpactosOds.items))
      this.optImpactosOds.page = Math.ceil(this.optImpactosOds.total / this.optImpactosOds.items);
    this.getImpactosOdsForImpacto();
  };

  viewImpactoOds = x => {
    this.UI.showDialog({
      size: 'md',
      template: require('./impacto.ods.info.dialog.html'),
      controller: ['$scope', function ($scope) {
        $scope.data = angular.copy(x);
        $scope.data.dataCriacao = moment($scope.data.dataCriacao).format('DD/MM/YYYY HH:mm:ss');
        $scope.fechar = function () {
          $scope.$close();
        };
      }]
    });
  };

  // Permissions
  // read: (ownPermission, allowAll, adminPermission, users)
  // edit: (ownPermission, allowOwn, adminPermission, users)
  canReadGeneral = () => this.ProdutoService.canRead('produtoRead', true, 'produtoReadAny', this.ProdutoService.getInvestigadorUserId(this.data));
  canEditGeneral = () => this.ProdutoService.canEdit('produtoEdit', true, 'produtoEditAny', this.ProdutoService.getInvestigadorUserId(this.data));

  canReadAdicional = () => this.ProdutoService.canRead('produtoReadAdicional', true, 'produtoReadAdicionalAny', this.ProdutoService.getInvestigadorUserId(this.data));
  canEditAdicional = () => this.ProdutoService.canEdit('produtoEditAdicional', true, 'produtoEditAdicionalAny', this.ProdutoService.getInvestigadorUserId(this.data));

  canReadInvestigador = () => this.ProdutoService.canRead('produtoReadInvestigador', true, 'produtoReadInvestigadorAny', this.ProdutoService.getInvestigadorUserId(this.data));
  canEditInvestigador = () => this.ProdutoService.canEdit('produtoEditInvestigador', true, 'produtoEditInvestigadorAny', this.ProdutoService.getInvestigadorUserId(this.data));

  canReadEntidadeFinanciadora = () => this.ProdutoService.canRead('produtoReadEntidadeFinanciadora', true, 'produtoReadEntidadeFinanciadoraAny', this.ProdutoService.getInvestigadorUserId(this.data));
  canEditEntidadeFinanciadora = () => this.ProdutoService.canEdit('produtoEditEntidadeFinanciadora', true, 'produtoEditEntidadeFinanciadoraAny', this.ProdutoService.getInvestigadorUserId(this.data));

  canReadImpacto = () => this.ProdutoService.canRead('produtoReadImpacto', true, 'produtoReadImpactoAny', this.ProdutoService.getInvestigadorUserId(this.data));
  canEditImpacto = () => this.ProdutoService.canEdit('produtoEditImpacto', true, 'produtoEditImpactoAny', this.ProdutoService.getInvestigadorUserId(this.data));

}

ProdutoDetailsController.$inject = ['$q', '$state', '$scope', 'AuthenticationService', 'UIService', 'ProdutoService', 'Produto', 'ProdutoInvestigador', 'ProdutoEntidadeFinanciadora', 'ProdutoTipo', 'Investigador', 'EntidadeFinanciadora', 'Impacto', 'ImpactoOds', 'Ods', 'Pais'];
